<template>
  <div>
    <!-- <div class="Fuell-Toolbar">
      <button
        class="Fuell-ToolbarButton ml-auto blue"
        @click="handleCreateMerchant()"
      >
        <span
          class="Fuell-ToolbarButton--label"
          v-t="{path:'merchant_settings_merchant_create_button'}"
        >
        </span>
      </button>
    </div> -->
    <merchants-table @showMerchantDetailModal="showMerchantDetailModal"></merchants-table>
    <merchant-detail-modal :open.sync="showMerchantDetailModalFlag" :merchantId="currentMerchantId" @created="showMerchantDetailModal" v-if="showMerchantDetailModalFlag"></merchant-detail-modal>
  </div>
</template>

<script>
import MerchantsTable from '../../_components/merchants/MerchantsTable'
import MerchantDetailModal from '../../_components/merchants/MerchantDetailModal'
export default {
  name: 'MerchantSettingsIndex',
  components: {
    MerchantsTable,
    MerchantDetailModal
  },
  data () {
    return {
      showMerchantDetailModalFlag: false,
      currentMerchantId: 0
    }
  },
  methods: {
    async fetchMerchants () {
      await this.$store.dispatch('MerchantsStore/fetchMerchants')
    },
    showMerchantDetailModal (event) {
      this.currentMerchantId = event
      this.showMerchantDetailModalFlag = true
    },
    handleCreateMerchant () {
      this.showMerchantDetailModalFlag = true
      this.currentMerchantId = null
    }
  },
  async created () {
    await this.fetchMerchants()
  }
}
</script>
